import type * as React from 'react';

import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import type { Xinglet } from '@xing-com/crate-xinglet';

import { SocialBar } from './components';
import type { SocialBarProps } from './components';

export default class SocialBarXinglet implements Xinglet {
  public getComponent(): React.VFC<SocialBarProps> {
    return (props): JSX.Element => {
      const { getSearchParameter } = useSearchParameter();
      const inputHintClick = !!getSearchParameter('input_hint_click');

      return <SocialBar {...{ ...props, inputHintClick }} />;
    };
  }

  /**
   * Preload the Xinglet
   * @returns
   */
  public async '@xing-com/crate-social-bar-xinglet.load'(): Promise<void> {
    return;
  }
}
